<script>
import {
  bApp,
  baseTermUrl,
  insTypeOrders,
  insTypeName,
  instypeSummary,
  preHandleKeys,
  accShowKeys,
  hideKey,
  addAndTakeHead,
} from 'base/config'
import { formatTenThousand, formatASCII } from 'common/js/format'
import Insurance from 'base/model/insurance'
import { toggleClass } from 'common/js/dom'
import ToggleDesc from 'components/toggleDesc/toggleDesc'
import PbDialog from 'components/dialog/dialog'

const ZJLQ_TYPE = '万能账户'
const SHOW_PRODUCT_NAME = [1, 3, 6, 8]
const myShowKeys = ['description1']

export default {
  components: {
    ToggleDesc,
    PbDialog,
  },
  props: {
    temp: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    },
    productNameList: {
      type: Object,
      default: () => ({})
    },
    showType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  methods: {
    /**
     * 显示/隐藏 责任
     * @param  {Element} dom [责任所在dom]
     */
    toggleDesc(dom) {
      dom.parentNode && toggleClass(dom.parentNode, 'ins-desc-show')
    },
    /**
     * 显示/隐藏 病种
     * @param  {Array} path [病种路径]
     */
    // toggleDis(path) {

    //   this.$emit('disShow', path)
    // },
    /**
     * 显示/隐藏 病种
     * @param  {Object} event
     * @param  {Object} path  [路径]
     */
    clickHandler(event, path) {
      this.$emit('openDisease', 'open-disease', path)
    },
    /**
     * 格式数据
     * @return {Object} [险种格式数据, 责任格式数据]
     */
    _normalizeData() {
      let diseasesPath = []
      let arrangeInIns = []
      let arrangeInInsType = []
      let accidentInIns = []

      const temp = this.temp.liabilities
      const accountMap = this.temp.accountMap
      const categorySort = this.temp.categorySort || 'normal'
      const insTypeOrder = insTypeOrders[categorySort]
      if (!Array.isArray(temp)) {
        return {
          diseasesPath,
          arrangeInIns,
          arrangeInInsType,
          accidentInIns,
        }
      }

      for (let pidx = 0, plen = temp.length; pidx < plen; pidx++) {
        let product = temp[pidx] // 产品
        let productId = product.productId
        let insurance = product.insuranceLiabilities
        let insuranceLen = insurance && insurance.length
        let arrangeProduct = []
        let accProduct = []

        let accInsurance = product.accidentLiabilities
        let accInsuranceLen = accInsurance && accInsurance.length

        if (!insuranceLen && !accInsuranceLen) continue
        for (let idx = 0; idx < insuranceLen; idx++) {
          let ins = insurance[idx] // 险种
          let insId = ins.insuranceId // 险种id
          let insName = ins.insuranceName // 险种名字
          let liabilities = ins.liabilities // 责任
          let liabilitiesLen = liabilities && liabilities.length

          let disease // 险种-所有责任的病重
          let instypeDisease = {}
          let insDisease = []
          // if (!liabilitiesLen) {

          //   continue
          // }
          for (let lidx = 0; lidx < liabilitiesLen; lidx++) {
            let liab = liabilities[lidx] // 责任
            let liabType = liab.categoryId // 责任类别
            let liabTypeName = liab.categoryName || insTypeName[liabType - 1] // 责任类别名
            let liabOrder = insTypeOrder.indexOf(liabType) // 责任排序

            if (liabOrder < 0) continue
            // 病种
            // if (liab.disease && liab.disease.title) {
            //   disease = {
            //     pidx, // 产品index
            //     idx,  // 险种
            //     lidx  // 责任
            //   }

            //   if (Array.isArray(instypeDisease[liabOrder])) {
            //     instypeDisease[liabOrder].push(disease)
            //   } else {
            //     instypeDisease[liabOrder] = [disease]
            //   }

            //   if (Array.isArray(insDisease[pidx])) {
            //     insDisease[pidx].push(disease)
            //   } else {
            //      insDisease[pidx] = [disease]
            //   }

            //   // 病种集合
            //   diseasesPath.push(disease)
            // }

            // 同责任类型的
            if (Array.isArray(arrangeInInsType[liabOrder])) {
              let matchingInsType = arrangeInInsType[liabOrder]
              let matchLen = matchingInsType.length - 1 || 0
              let exItem = matchingInsType[matchLen]

              let itDisease = instypeDisease[liabOrder]

              if (
                exItem.insuranceId === insId &&
                exItem.liabilities &&
                exItem.liabilities.length
              ) {
                // 全部病种路径存储在第一条责任
                // disease && exItem.disease.push(disease)
                exItem.liabilities.push(liab)
                // 前责任无病种，后有病种需赋值
                // if (!exItem.disease && disease) {
                //   exItem.disease = disease
                //   exItem.itDisease = itDisease
                // }
              } else {
                arrangeInInsType[liabOrder].push({
                  productId,
                  insuranceId: insId,
                  insuranceName: insName,
                  liabilities: [liab],
                  disease, //: [disease]
                  itDisease,
                  liabTypeName,
                })
              }
            } else {
              arrangeInInsType[liabOrder] = [
                {
                  productId,
                  insuranceId: insId,
                  insuranceName: insName,
                  liabilities: [liab],
                  disease, //: [disease]
                  itDisease: instypeDisease[liabOrder],
                  liabTypeName,
                },
              ]
            }
          }

          let arrangeMap = {
            productId,
            disease,
            insDisease,
            ins,
          }

          if (accountMap[productId] && accountMap[productId][insId]) {
            let liabType = insTypeName.indexOf(ZJLQ_TYPE) + 1
            let liabOrder = insTypeOrder.indexOf(liabType)

            let insAccountMap = accountMap[productId][insId]

            let accountIndex = this._getAccountLiabIndex(
              arrangeInInsType[liabOrder],
              { productId, insId }
            )

            // [万能账户]已存在，且追加领取
            // 1. 责任-追加领取
            if (accountIndex > -1) {
              arrangeInInsType[liabOrder][accountIndex].accountMap =
                insAccountMap
            } else {
              let arrangeTypeMap = {
                productId,
                insuranceId: insId,
                insuranceName: insName,
                // liabilities: [liab],
                liabTypeName: ZJLQ_TYPE,
                accountMap: insAccountMap,
              }
              if (Array.isArray(arrangeInInsType[liabOrder])) {
                arrangeInInsType[liabOrder].push(arrangeTypeMap)
              } else {
                arrangeInInsType[liabOrder] = [arrangeTypeMap]
              }
            }
            // 2. 险种-追加领取
            arrangeMap.accountMap = insAccountMap
          }
          arrangeProduct.push(arrangeMap)
        }

        if (accInsuranceLen) {
          for (let accIndex = 0; accIndex < accInsuranceLen; accIndex++) {
            let ins = accInsurance[accIndex] // 险种

            let accMap = {
              productId,
              // disease,
              ins,
            }
            accProduct.push(accMap)
          }
        }
        arrangeInIns.push(arrangeProduct)
        accProduct.length && accidentInIns.push(accProduct)
      }

      return {
        diseasesPath,
        arrangeInIns,
        arrangeInInsType,
        accidentInIns,
      }
    },
    /**
     * 创建险种
     * @param  {Array} template [description]
     */
    _createInsVNode(template) {
      let prodAry = []
      let {
        __c,
        temp: { username, trades, insuranceTypeId },
      } = this
      // 产品数
      let productsLen = template.length
      // 产品
      template.forEach((products, index) => {
        let insAry = []
        let tradesVNode
        // 产品 - <险种>
        products.forEach((item, insIdx) => {
          let ins = item.ins
          let productId = item.productId
          let accountMap = item.accountMap
          // let bLastInsHideDesc = false
          let liabilities = ins.liabilities
          let insChilds = []
          let bCompleteIns = false

          // 条款 VNode
          let termVNode = __c('a', {
            class: 'term-link after-bdr',
            attrs: {
              href: `${baseTermUrl}?nw=1&name=${username}&termsId=${ins.insuranceId}`,
              'data-stat-id': 'tkxq',
              'data-stat-ep': JSON.stringify({
                productId: insuranceTypeId,
              }),
            },
            domProps: {
              innerHTML: '条款',
            },
          })
          let headChilds = [ins.insuranceName, termVNode]
          // , bHideDesc
          let { bDisease } = this._haveDisease(liabilities)

          // 病种 VNode
          if (bDisease) {
            let diseaseBtnVNode = __c('a', {
              class: 'dis-link after-bdr',
              domProps: {
                innerHTML: '病种',
              },
              on: {
                click: this.clickHandler.bind(this, event, item.insDisease),
                //this.toggleDis.bind(this, item.disease)
              },
            })
            headChilds.push(diseaseBtnVNode)
          }
          // 险种 head
          let insHeadVNode = __c(
            'h3',
            {
              class: 'ins-name',
            },
            headChilds
          )
          insChilds.push(insHeadVNode)

          // 险种 body
          if (ins && Array.isArray(liabilities) && liabilities.length) {
            // 正常险种
            let insBodyChilds = this._createLiabilities(productId, liabilities)
            let insBodyVNode = __c(
              'div',
              {
                class: 'ins-bd',
              },
              insBodyChilds
            )
            insChilds.push(insBodyVNode)
            bCompleteIns = true
          }

          // 追加领取
          if (accountMap) {
            let insAddAndTakeChilds = this._createAddAndTake(accountMap)
            if (insAddAndTakeChilds.length) {
              let insAddAndTakeVNode = __c(
                'div',
                {
                  class: 'ins-bd add-take',
                },
                insAddAndTakeChilds
              )
              insChilds.push(insAddAndTakeVNode)
              bCompleteIns = true
            }
          }

          // 险种 foot
          // let insFootVNode
          // if (bHideDesc) {
          //   insFootVNode = __c(ToggleDesc, {
          //     on: {
          //       toggle: this.toggleDesc
          //     }
          //   })
          //   // 交易且有隐藏文案
          //   bLastInsHideDesc = true
          //   insChilds.push(insFootVNode)
          // }

          // 交易
          // 产品中最后险种
          if (
            Array.isArray(trades) &&
            trades.length >= 1 &&
            productsLen > 1 &&
            insIdx === 0
          ) {
            // 是否交易产品
            let tradesIdx = this._getTradesIndex(productId)
            if (tradesIdx > -1) {
              let tradesInfo = trades[tradesIdx].productInfo
              if (tradesInfo && tradesInfo.tradeUrl) {
                tradesVNode = __c('div', {
                  // bLastInsHideDesc ? 'trades-inner-wrap' : 'trades-wrap'
                  class: 'trades-wrap',
                  domProps: {
                    innerHTML: `<a class="trades-btn" href="${
                      bApp ? tradesInfo.tradeUrl : tradesInfo.shareTradeUrl
                    }">立即投保</a>`,
                  },
                })
                insChilds.push(tradesVNode)
              }
            }
          }

          let insVNode
          bCompleteIns &&
            insChilds.length &&
            (insVNode = __c(
              'div',
              {
                class: 'ins-box',
              },
              insChilds
            ))
          bCompleteIns && insChilds.length && insAry.push(insVNode)
        })

        let prodVNodes = __c(
          'section',
          {
            class: 'prod-box',
          },
          insAry
        )
        prodAry.push(prodVNodes)
      })

      return __c(
        'article',
        {
          class: 'des-box',
        },
        prodAry
      )
    },
    /**
     * 创建责任
     * @param  {Array} template [description]
     */
    _createInsTypeVNode(template) {
      let {
        productNameList,
        temp: { name, categorySort, insuranceTypeId },
        __c,
        _haveDisease,
        _createLiabilities,
        // _createAddAndTake,
        _bShowProductName,
        _createProductVNode,
      } = this

      // const tLen = template.length
      const insTypeOrder = insTypeOrders[categorySort || 'normal']

      let instypeAry = []
      // let bToggleDesc = false

      template.forEach((instype, idx) => {
        const insTypeKind = insTypeOrder[idx]
        const bProductShow = _bShowProductName(instype, insTypeKind)
        // const bInstypeSummary = false

        let insAry = []
        let liabTypeName = ''
        // let bInstypeHideDesc = false
        let bInstypeDisease = false
        let bAddAndTake = 0
        // let itDisease = []
        let preProductName = null

        instype.forEach((ins, lidx) => {
          const liabilities = ins.liabilities
          const productId = ins.productId
          const productName = productNameList[productId]

          let insChilds = []
          let bInsBodyVNode = false

          if (bProductShow && preProductName != productName) {
            insAry = insAry.concat(
              _createProductVNode(productName, preProductName)
            )
            preProductName = productName
          }

          // itDisease.push(ins.itDisease)

          // 条款 VNode
          let termVNode = __c('a', {
            class: 'term-link',
            attrs: {
              href: `${baseTermUrl}?nw=1&name=${name}&termsId=${ins.insuranceId}`,
              'data-stat-id': 'tkxq',
              'data-stat-ep': JSON.stringify({
                productId: insuranceTypeId,
              }),
            },
            domProps: {
              innerHTML: '条款',
            },
          })
          let headChilds = [ins.insuranceName, termVNode]
          let accountMap = ins.accountMap
          // bHideDesc
          let { bDisease } = _haveDisease(liabilities)

          // 病种 VNode
          if (bDisease) {
            // let diseaseBtnVNode = create('a', {
            //   class: 'dis-link',
            //   domProps: {
            //     innerHTML: '病种'
            //   },
            //   on: {
            //     click: this.toggleDis.bind(this, ins.disease)
            //   }
            // })
            // headChilds.push(diseaseBtnVNode)

            !bInstypeDisease && (bInstypeDisease = true)
          }
          // 险种 head
          let insHeadVNode = __c(
            'h5',
            {
              class: 'ins-name',
            },
            headChilds
          )
          insChilds.push(insHeadVNode)

          // 险种head都隐藏
          // bHideDesc = true;

          // 险种 body
          if (liabilities) {
            // 正常险种
            let insBodyChilds = _createLiabilities(productId, liabilities)

            if (insBodyChilds.length) {
              let insBodyVNode = __c(
                'div',
                {
                  class: 'ins-bd',
                },
                insBodyChilds
              )
              insChilds.push(insBodyVNode)
              bInsBodyVNode = true
            }
          }

          // 追加领取
          // if (accountMap)  {
          //   let insAddAndTakeChilds = _createAddAndTake(accountMap)

          //   if (insAddAndTakeChilds.length) {
          //     let insAddAndTakeVNode = __c('div', {
          //       class: 'ins-bd add-take'
          //     }, insAddAndTakeChilds)
          //     insChilds.push(insAddAndTakeVNode)
          //     bAddAndTake++
          //   }
          // }

          // 险种 foot
          // let insFootVNode
          // if (!bInstypeHideDesc && bHideDesc) {
          //   bInstypeHideDesc = bHideDesc
          //   insChilds.push(insFootVNode)
          // }

          let insVNode
          insChilds.length &&
            bInsBodyVNode &&
            (insVNode = __c(
              'div',
              {
                class: 'ins-box',
              },
              insChilds
            ))

          // 类别名 设置一次
          if (lidx === 0) {
            liabTypeName = ins.liabTypeName
          }

          // 万能账户： 责任+追加领取 都存在则添加
          if (ins.liabTypeName === ZJLQ_TYPE) {
            if ((bAddAndTake > 0 || bInsBodyVNode) && insChilds.length) {
              insAry.push(insVNode)
            }
          } else {
            insChilds.length && bInsBodyVNode && insAry.push(insVNode)
          }
        })

        // 险种类别名
        // 没有险种信息（追加领取）
        if (insAry.length) {
          let instypeNameChild = [liabTypeName]
          // if (bInstypeDisease) {
          //   let instypeDiseaseVNode = __c('a', {
          //     class: 'disease-btn after-bdr',
          //     on: {
          //       click: this.clickHandler.bind(this, event, itDisease)
          //     },
          //   }, '病种')
          //   instypeNameChild.push(instypeDiseaseVNode)
          // }

          let instypeNameVNode = __c(
            'h3',
            {
              class: 'instype-name',
            },
            instypeNameChild
          )
          insAry.unshift(instypeNameVNode)

          let summaryText = instypeSummary[insTypeKind]
          if (summaryText && bProductShow) {
            insAry.push(
              __c(
                'div',
                {
                  class: 'summary',
                },
                summaryText
              )
            )
          }

          // 显示
          // if (bInstypeHideDesc) {
          //   let instypeToggleFootVNode = __c(ToggleDesc, {
          //     on: {
          //       toggle: this.toggleDesc
          //     }
          //   })
          //   insAry.push(instypeToggleFootVNode)
          // }

          // let sectionClass =
          // bAddAndTake > 0
          //   ? bAddAndTake > 1
          //     ? 'instype-box addtake-box'
          //     : 'instype-box addtake-box no-title'
          //   : 'instype-box'

          let instypeVNodes = __c(
            'section',
            {
              class: 'instype-box',
              // bAddAndTake > 1 ? 'instype-box addtake-box' : 'instype-box',
            },
            insAry
          )

          instypeAry.push(instypeVNodes)
        }
      })

      return __c(
        'article',
        {
          class: 'des-box',
        },
        instypeAry
      )
    },
    _createAccidentVNode(template) {
      let prodAry = []
      let {
        __c,
        // temp: { username, trades },
      } = this
      // 产品数
      let productsLen = template.length
      // 产品
      template.forEach((products, index) => {
        let insAry = []
        let headlineVNode
        let tradesVNode
        let bProdHideDesc = false

        // 产品 - <险种>
        products.forEach((item, insIdx) => {
          let ins = item.ins
          let productId = item.productId
          let accountMap = item.accountMap
          let bLastInsHideDesc = false
          let liabilities = ins.liabilities
          let insChilds = []
          let bCompleteIns = false

          // 条款 VNode
          // let termVNode = create('a', {
          //   class: 'term-link after-bdr',
          //   attrs: {
          //     href: `${baseTermUrl}?nw=1&name=${username}&termsId=${ins.insuranceId}`,
          //     'data-stat-id': 'tkxq',
          //     'data-stat-ep': JSON.stringify({
          //       productId: this.temp.insuranceTypeId
          //     })
          //   },
          //   domProps: {
          //     innerHTML: '条款'
          //   }
          // })
          // let headChilds = [ins.insuranceName, termVNode]
          // bDisease,
          let { bHideDesc } = this._haveDisease(liabilities)

          // 病种 VNode
          // if (bDisease) {
          //   let diseaseBtnVNode = create('a', {
          //     class: 'dis-link after-bdr',
          //     domProps: {
          //       innerHTML: '病种'
          //     },
          //     on: {
          //       click: this.clickHandler.bind(this, event, item.disease)
          //       //this.toggleDis.bind(this, item.disease)
          //     }
          //   })
          //   headChilds.push(diseaseBtnVNode)
          // }
          // 险种 head

          if (insIdx === 0) {
            headlineVNode = __c('h3', {
              class: 'ins-name after-bd-b',
              domProps: {
                innerHTML: liabilities[insIdx].headline,
              },
            })
          }

          // insChilds.push(insHeadVNode)

          // 险种 body
          if (ins && Array.isArray(liabilities) && liabilities.length) {
            // 正常险种
            let insBodyChilds = this._createAccLiabilities(
              productId,
              liabilities
            )
            let insBodyVNode = __c(
              'div',
              {
                class: 'ins-bd',
              },
              insBodyChilds
            )
            insChilds.push(insBodyVNode)
            bCompleteIns = true
          }

          // 追加领取
          // if (accountMap) {
          //   let insAddAndTakeChilds = this._createAddAndTake(accountMap, create)
          //   if (insAddAndTakeChilds.length) {
          //     let insAddAndTakeVNode = create('div', {
          //       class: 'ins-bd add-take'
          //     }, insAddAndTakeChilds)
          //     insChilds.push(insAddAndTakeVNode)
          //     bCompleteIns = true
          //   }
          // }

          // 险种 foot
          // let insFootVNode
          if (bHideDesc && !bProdHideDesc) {
            bProdHideDesc = true
            // insFootVNode = create(ToggleDesc, {
            //   on: {
            //     toggle: this.toggleDesc
            //   }
            // })
            // 交易且有隐藏文案
            // bLastInsHideDesc = true
            // insChilds.push(insFootVNode)
          }

          // 交易
          // 产品中最后险种
          // if (Array.isArray(trades) && trades.length >= 1 && productsLen > 1 && insIdx === 0) {
          //   // 是否交易产品
          //   let tradesIdx = this._getTradesIndex(productId)
          //   if (tradesIdx > -1) {
          //     let tradesInfo = trades[tradesIdx].productInfo
          //     if (tradesInfo && tradesInfo.tradeUrl) {
          //       tradesVNode = create('div', {
          //         class: bLastInsHideDesc ? 'trades-inner-wrap' : 'trades-wrap',
          //         domProps: {
          //           innerHTML: `<a class="trades-btn" href="${bApp ? tradesInfo.tradeUrl : tradesInfo.shareTradeUrl}">立即投保</a>`
          //         },
          //       })
          //       insChilds.push(tradesVNode)
          //     }
          //   }
          // }

          let insVNode
          bCompleteIns &&
            insChilds.length &&
            (insVNode = __c(
              'div',
              {
                class: 'ins-box',
              },
              insChilds
            ))
          bCompleteIns && insChilds.length && insAry.push(insVNode)
        })

        let prdFootVNode
        if (bProdHideDesc) {
          prdFootVNode = __c(ToggleDesc, {
            on: {
              toggle: this.toggleDesc,
            },
          })
          // 交易且有隐藏文案
          // bLastInsHideDesc = true
          insAry.push(prdFootVNode)
        }

        insAry.unshift(headlineVNode)

        let prodVNodes = __c(
          'section',
          {
            class: 'prod-box',
          },
          insAry
        )
        prodAry.push(prodVNodes)
      })

      return __c(
        'article',
        {
          class: 'acc-box',
        },
        prodAry
      )
    },
    /**
     * 创建责任（普通）
     * @param  {Number} prodId [产品id]
     * @param  {Object} liab   [责任对象]
     * @return {Array}         [VNode, VNode]
     */
    _createLiabilities(prodId, liab) {
      let ret = []
      const { data, __c, format, formatLow } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib) => {
        lib &&
          myShowKeys.forEach((sk) => {
            let libItem = lib[sk]
            if (libItem) {
              let resultHTML
              try {
                resultHTML = format(prodId, libItem, data)
              } catch (er) {
                resultHTML = formatLow(prodId, libItem, data)
              }
              resultHTML = formatASCII(resultHTML)

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length &&
                  preHandleKeys.forEach((pre) => {
                    if (pre.key === sk) {
                      resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                    }
                  })

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML,
                  },
                })
                ret.push(libVNode)
              }
            }
          })
      })

      return ret
    },
    _createAccLiabilities(prodId, liab) {
      let ret = []
      const { data, __c, format, formatLow } = this
      let targetAry = liab
      if (!Array.isArray(liab)) {
        targetAry = [liab]
      }
      targetAry.forEach((lib, index) => {
        let accLib = []
        let accLibVNode

        lib &&
          accShowKeys.forEach((sk, idx) => {
            let libItem = lib[sk]
            let bIconfont = false
            if (sk === 'description1') {
              bIconfont = true
            }
            if (libItem) {
              let resultHTML
              try {
                resultHTML = format(prodId, libItem, data)
              } catch (er) {
                resultHTML = formatLow(prodId, libItem, data)
              }
              resultHTML = formatASCII(resultHTML)

              let libVNode
              // fix 无文字时插入空的dom
              if (resultHTML) {
                // 文字预处理
                preHandleKeys.length &&
                  preHandleKeys.forEach((pre) => {
                    if (pre.key === sk) {
                      resultHTML = pre.value.replace(/{(.*?)}/, resultHTML)
                    }
                  })

                if (bIconfont) {
                  resultHTML = `<i class="iconfont icon-${lib['iconfont']}"></i>${resultHTML}`
                }

                libVNode = __c('div', {
                  class: sk,
                  domProps: {
                    innerHTML: resultHTML,
                  },
                })
                accLib.push(libVNode)
              }
            }
            if (idx === accShowKeys.length - 1 && accLib.length) {
              accLibVNode = __c(
                'div',
                {
                  class: 'acc-lib after-bd-b',
                },
                accLib
              )
            }
          })

        accLibVNode && ret.push(accLibVNode)
      })

      return ret
    },
    /**
     * 创建追加领取
     * @param  {Object} account [追加领取]
     */
    _createAddAndTake(account) {
      let ret = []
      let { __c } = this
      let addAndTake = account.addAndTakeData
      let result = {
        add: [],
        take: [],
      }
      if (!account || !addAndTake.length) return ret
      if (addAndTake && Array.isArray(addAndTake)) {
        addAndTake.forEach((at) => {
          if (Array.isArray(at.adjustData) && at.adjustData.length > 0) {
            result[at.key] = at.adjustData
          }
        })
      }

      let addChilds = []
      let takeChilds = []
      if (result.add.length) {
        let addHeadVNode = __c('div', {
          class: 'description1',
          domProps: {
            innerHTML: addAndTakeHead[0],
          },
        })
        addChilds.push(addHeadVNode)

        result.add.forEach((addItem) => {
          let addItemVNode = __c('div', {
            class: 'description2',
            domProps: {
              innerHTML: this._transformText('add', addItem),
            },
          })
          addChilds.push(addItemVNode)
        })
        let addVNode = __c(
          'div',
          {
            class: 'account-item',
          },
          addChilds
        )
        ret.push(addVNode)
      }
      if (result.take.length) {
        let takeHeadVNode = __c('div', {
          class: 'description1',
          domProps: {
            innerHTML: addAndTakeHead[1],
          },
        })
        takeChilds.push(takeHeadVNode)
        result.take.forEach((addItem) => {
          let addItemVNode = __c('div', {
            class: 'description2',
            domProps: {
              innerHTML: this._transformText('take', addItem),
            },
          })
          takeChilds.push(addItemVNode)
        })
        let takeVNode = __c(
          'div',
          {
            class: 'account-item',
          },
          takeChilds
        )
        ret.push(takeVNode)
      }
      return ret
    },
    /**
     * 追加领取责任
     * @param  {String} type [add|take]
     * @param  {Array}  ary  [当年信息]
     * @return {String}      [责任描述]
     */
    _transformText(type, ary) {
      let start = ary[0]
      let end = ary[1]
      let money = ary[2]
      let insuredAge = this.temp.insuredAge
      let age = insuredAge + start
      let hand = type === 'add' ? '交' : '领'
      if (start === end) {
        return `${age}岁${hand}<span>${money}</span>元`
      } else if (start < end) {
        let eage = insuredAge + end
        return `${age}岁—${eage}岁每年${hand}<span>${money}</span>元`
      }
    },
    /**
     * 险种下的责任是否有病种
     * @param  {Array/Object} data [责任]
     * @return {Boolean}           [是否有病种]
     */
    _haveDisease(data, type) {
      let bDisease = false
      let bHideDesc = false

      let targetAry = data
      if (!Array.isArray(data)) {
        targetAry = [data]
      }
      for (let index = 0; index < targetAry.length; index++) {
        if (
          targetAry[index] &&
          targetAry[index].disease &&
          targetAry[index].disease.title
        ) {
          bDisease = true
        }
        if (targetAry[index] && targetAry[index][hideKey]) {
          bHideDesc = true
        }
        if (
          (type === 0 && bDisease) ||
          (type === 1 && bHideDesc) ||
          (!type && bDisease && bHideDesc)
        )
          break
      }
      return {
        bDisease,
        bHideDesc,
      }
    },
    _getTradesIndex(productId) {
      let {
        temp: { trades },
      } = this
      let index = -1
      if (!Array.isArray(trades) || trades.length < 1) return index
      for (var i = 0, len = trades.length; i < len; i++) {
        if (trades[i].productId === productId) {
          index = i
          break
        }
      }
      return index
    },
    /**
     * 带有责任的万能账户是否已存在
     * @param  {Array} list                [责任类型集合]
     * @param  {Number} options.productId  [产品id]
     * @param  {Number} options.insuranceId[险种id]
     * @return {Number}                    [序号]
     */
    _getAccountLiabIndex(list, { productId, insId }) {
      let targetList = list || []
      let index = -1
      for (var i = 0, j = targetList.length; i < j; i++) {
        let targetIns = targetList[i]
        if (
          targetIns.productId === productId &&
          targetIns.insuranceId === insId
        ) {
          index = i
          break
        }
      }
      return index
    },
    /**
     * 创建产品名节点
     * @param  {String} name [名称]
     * @param  {Bollean} segm [分割]
     * @return {Array}      [list[VNode]]
     */
    _createProductVNode(name, segm) {
      let rst = []
      let { __c } = this
      if (segm) {
        rst.push(
          __c('div', {
            class: 'product-name-line after-bd-b',
          })
        )
      }
      rst.push(
        __c(
          'h4',
          {
            class: 'product-name',
          },
          name
        )
      )

      return rst
    },
    /**
     * 是否需要分产品显示
     *   - in (身价保障1 疾病保障3 伤残保障8 / 保费豁免6)
     *   - >= 2个产品
     * @param  {Array} list [同责任类型的险种列表]
     * @param  {Number} index [责任类型]
     * @return {Boolean}
     */
    _bShowProductName(list, index) {
      const { productNameList } = this
      let count = 0

      if (SHOW_PRODUCT_NAME.indexOf(index) < 0) return

      if (index === 6) {
        for (var pid in productNameList) {
          if (productNameList[pid]) count++
        }
      } else {
        let pids = []
        list.forEach((item) => {
          const pid = item.productId
          if (pids.indexOf(pid) < 0) {
            pids.push(pid)
            count++
          }
        })
      }

      return false //count >= 2
    },
    /**
     * 填充责任中不存在的险种
     * @param  {String} template [模版]
     * @param  {Array}  keys     [险种key]
     * @param  {Array}  dataList [数据段]
     * @return {Object} key
     *                  dataList
     */
    _stuffingTemplateIns(template, keys, dataList) {
      let tpKeys = template.match(/i\d+/g)
      tpKeys = [...new Set(tpKeys)]
      let iKeys = keys.filter((k) => {
        return k.match(/i\d+/)
      })

      let notKeys = tpKeys.filter((d) => {
        return iKeys.indexOf(d) === -1
      })

      notKeys.forEach((nk) => {
        keys.push(nk)
        dataList.push(new Insurance())
      })

      return {
        keys,
        dataList,
      }
    },
    /**
     * 转义，公共函数
     * @param  {[type]} templateData [pre模版，数据]
     * @return {[type]}              [模版]
     */
    _formatFnCenter(templateData) {
      var resultTemp = templateData[0]

      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i])

        // 金额显示整万
        if (templateData[i].match(/元/)) {
          arg = String(formatTenThousand(arg))
        }

        // 金额显示保留2位小数
        // fix 纯数字才进入逻辑
        if (!isNaN(arg) && arg.split('.')[1]) {
          arg = arg.split('.')[1].length > 2 ? parseFloat(arg).toFixed(2) : arg
        }
        resultTemp += arg
        resultTemp += templateData[i]
      }
      return resultTemp
    },
    /**
     * 转义字符串模版
     * @param  {Number} prodId   [产品id]
     * @param  {String} template [pre模版]
     * @param  {Object} data     [计算数据]
     * @return {String}          [模版]
     */
    format(prodId, template, data) {
      let self = this
      let keys = Object.keys(data)
      let dataList
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = this._stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      // 这里使用反引号来构建模板引擎
      // let Fn = new Function
      let g = new Function(
        keys.join(','),
        'return this._formatFnCenter `' + template + '`;'
      )
      return g.apply(self, dataList)
    },
    /**
     * ios8-5c fix (format) 方法
     */
    formatLow(prodId, template, data) {
      let self = this
      let temps = template.split(/\$\{(\w?[^\}]*)\}/g)
      let match = template.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g)

      let dataList
      let keys = Object.keys(data)
      dataList = keys.map(function (key) {
        // 根据产品id获取对应险种数据
        if (key.match(/i\d+/)) {
          if (data[key] && data[key]['p' + prodId]) {
            return data[key]['p' + prodId]
          } else {
            return new Insurance()
          }
        }
        return data[key]
      })

      // -- start 12.15 --
      let stuff = this._stuffingTemplateIns(template, keys, dataList)
      keys = stuff.keys
      dataList = stuff.dataList
      // -- end 12.15 --

      if (match) {
        for (var i = 1; i < temps.length; i += 2) {
          let ret = new Function(
            keys.join(','),
            'return ' + temps[i] + ';'
          ).apply(self, dataList)

          // 金额显示整万
          if (temps[i + 1].match(/元/)) {
            ret = String(formatTenThousand(ret))
          }
          ret = '' + ret
          // 金额显示保留2位小数
          if (!isNaN(Number(ret)) && ret.split('.')[1]) {
            ret =
              ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
          }
          temps[i] = ret
        }
        return temps.join('')
      } else {
        return template
      }
    },
  },
  // 依据大类型
  render: function (createElement) {
    this.__c = createElement
    let {
      showType,
      _createInsVNode,
      _createInsTypeVNode,
      _createAccidentVNode,
      _normalizeData,
    } = this
    // diseasesPath,
    let { arrangeInIns, arrangeInInsType, accidentInIns } = _normalizeData()

    const bAcc = accidentInIns[0] && accidentInIns[0].length

    this.$emit('setAccIns', 'set-accIns', bAcc)
    this.$emit('setInsType', 'set-instype', arrangeInInsType)
    // $emit('setDiseasesPath', 'set-disease', diseasesPath)

    if (showType === 0) {
      return _createInsVNode(arrangeInIns)
    } else {
      return createElement(
        'div',
        {
          class: 'genre-box',
        },
        [
          _createAccidentVNode(accidentInIns),
          _createInsTypeVNode(arrangeInInsType),
        ]
      )
    }
  },
}
</script>